import qs from 'qs'

import { Posting } from '@modules-deprecated/bankReconciliation/types'

import { Metable } from '../../types/metable'
import { getCurrentLocale, getRequest, postRequest, putRequest } from '../../utils'
import { DaybookAttachment } from './types/daybookAttachment'
import { DaybookTransaction } from './types/daybookTransaction'
import { DaybookTransactionLine } from './types/daybookTransactionLine'

export interface GetDaybookTransactionPayload {
  daybookTransactionId: string
  include?: string
}

export interface GetDaybookTransactionResponseData extends Metable {
  daybookTransaction: DaybookTransaction
}

export const getDaybookTransaction = ({
  daybookTransactionId,
  include = 'daybookTransaction.attachments:embed,attachment.file:embed,file.variants:embed',
}: GetDaybookTransactionPayload): Promise<GetDaybookTransactionResponseData> => {
  const locale = getCurrentLocale()
  const queryParams = qs.stringify({
    ...(include ? { include } : {}),
  })

  return getRequest(`/v2/daybookTransactions/${daybookTransactionId}?${queryParams}`, {
    'accept-language': locale,
  })
}

export const voidDaybookTransaction = ({ daybookTransactionId }: GetDaybookTransactionPayload): Promise<void> => {
  const locale = getCurrentLocale()

  const payload = {
    daybookTransaction: {
      id: daybookTransactionId,
      state: 'voided',
    },
  }

  return putRequest(`/v2/daybookTransactions/${daybookTransactionId}`, payload, {
    'accept-language': locale,
  })
}

export interface CreateDaybookTransactionPayload
  extends Omit<
    DaybookTransaction,
    'apiType' | 'attachments' | 'createdTime' | 'description' | 'extendedDescription' | 'id' | 'priority'
  > {
  attachments: DaybookAttachment[]
  lines: DaybookTransactionLine[]
}

export interface CreateDaybookTransactionResponseData extends Metable {
  daybookTransaction: DaybookTransaction[]
  postings: Posting[]
}

export const createDaybookTransaction = (
  payload: CreateDaybookTransactionPayload,
): Promise<CreateDaybookTransactionResponseData> => {
  const locale = getCurrentLocale()

  return postRequest(
    `/v2/daybookTransactions`,
    { daybookTransaction: payload },
    {
      'accept-language': locale,
    },
  )
}
